/**
 * Einstellungs-Navigation als reine Daten (W2-B5): die Bereiche und die
 * Texte-Slots leben hier, damit Sidebar (AppLayout/navModel), Router-Validierung
 * und die Einstellungs-Seite dieselbe Quelle teilen — React-frei, damit der
 * leichtgewichtige navModel-Duplikat-Test sie mitladen kann.
 */
export const SETTINGS_AREAS: { value: string; label: string }[] = [
  { value: 'betrieb', label: 'Betrieb' },
  // Kundentest 2026-08 (Faruq): Routing/Entfernungslauf aus „Betrieb" heraus
  // auf einen eigenen Bereich mit eigenem Sidebar-Unterpunkt.
  { value: 'entfernungen', label: 'Entfernungen' },
  { value: 'belege', label: 'Belege' },
  { value: 'texte', label: 'Texte' },
  { value: 'abrechnung', label: 'Abrechnung' },
  { value: 'mahnwesen', label: 'Mahnwesen' },
  { value: 'datev', label: 'DATEV' },
  { value: 'nummernkreise', label: 'Nummernkreise' },
];

export const SLOTS: { value: string; label: string }[] = [
  { value: 'DOC_INTRO', label: 'Kopftext (Beleg)' },
  { value: 'DOC_FOOTER', label: 'Fußtext (Beleg)' },
  { value: 'DOC_PAYMENT_TERMS', label: 'Zahlungsbedingungen' },
  { value: 'DOC_WARRANTY', label: 'Gewährleistung' },
  { value: 'DOC_REVOCATION', label: 'Widerrufsbelehrung' },
  { value: 'MAIL_SUBJECT', label: 'Mail-Betreff' },
  { value: 'MAIL_BODY', label: 'Mailtext' },
  { value: 'MAIL_SIGNATURE', label: 'Signatur' },
  { value: 'DUNNING_TEXT', label: 'Mahntexte' },
];
